import { render, staticRenderFns } from "./InscripcionCaribe.vue?vue&type=template&id=ba89d62a"
import script from "./InscripcionCaribe.vue?vue&type=script&lang=js"
export * from "./InscripcionCaribe.vue?vue&type=script&lang=js"
import style0 from "./InscripcionCaribe.vue?vue&type=style&index=0&id=ba89d62a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports